import ProcessRoutes from './process';
import LiquidationsRoutes from './liquidations';

export default [...ProcessRoutes, ...LiquidationsRoutes];
